export const SHOW_MODAL = 'SHOW_MODAL';
export const CLEAR_MODAL = 'CLEAR_MODAL';
export const GLOBAL_REQ_CANCEL = 'GLOBAL_REQ_CANCEL';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const BROADCAST_SET_PROGRAM = 'BROADCAST_SET_PROGRAM';

// User actions
export const GET_USER_FROM_SESSION = 'GET_USER_FROM_SESSION';

// Source action
export const BROADCAST_UPDATE_SOURCE = 'BROADCAST_UPDATE_SOURCE';
export const BROADCAST_DISCONNECT_SOURCE = 'BROADCAST_DISCONNECT_SOURCE';
// Template action
export const BROADCAST_TAKE_BACKGROUND_LIVE = 'BROADCAST_TAKE_BACKGROUND_LIVE';
